/** Ap Error. */
export class ApError extends Error {
    /**
     * Constructor.
     *
     * @param message The message.
     * @param context The context.
     * @param cause The cause (Optional).
     * @param showReloadOption Enables the option to reload the page (Optional).
     * @param title Title displaying above the error (Optional).
     */
    constructor(
        public message: string,
        public context: string,
        public cause?: Error,
        public showReloadOption: boolean = true,
        public title?: string
    ) {
        super(message);
        //@see https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, ApError.prototype);
    }
}
